/**
 * Enhanced Product Recommendations for Shopify
 * 
 * INSTALLATION INSTRUCTIONS:
 * 1. In your Shopify admin, go to Online Store > Themes
 * 2. Find your active theme and click "Actions" > "Edit code"
 * 3. Under the "Assets" folder, create a new file called "customer-recommendations.js"
 * 4. Paste this entire code into that file
 * 5. Then, in your theme.liquid file, add this line before the closing </body> tag:
 *    {{ 'customer-recommendations.js' | asset_url | script_tag }}
 */

document.addEventListener('DOMContentLoaded', function() {
  // Only run on the customer account page
  if (!document.querySelector('.customer-enhancements')) {
    return;
  }

  // Initialize customer data
  const customerData = {
    viewedProducts: getViewedProducts(),
    cartItems: getCartItems()
  };

  // Track product views for better recommendations
  trackProductViews();
  
  // Enhance "Buy Again" functionality
  enhanceBuyAgainButtons();

  // Add quick quantity selectors to Buy Again items
  addQuantitySelectors();

  /**
   * Get recently viewed products from localStorage
   */
  function getViewedProducts() {
    try {
      return JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];
    } catch (e) {
      return [];
    }
  }

  /**
   * Get current cart items if available
   */
  function getCartItems() {
    const cartItemsElement = document.getElementById('cartItemsData');
    if (cartItemsElement) {
      try {
        return JSON.parse(cartItemsElement.textContent);
      } catch (e) {
        return [];
      }
    }
    return [];
  }

  /**
   * Track product views for personalization
   */
  function trackProductViews() {
    // Only track on product pages
    if (!window.location.pathname.includes('/products/')) {
      return;
    }

    const productId = document.querySelector('meta[property="product:id"]')?.content;
    if (!productId) return;

    let viewedProducts = getViewedProducts();
    
    // Remove if already in list
    viewedProducts = viewedProducts.filter(id => id !== productId);
    
    // Add to beginning of list
    viewedProducts.unshift(productId);
    
    // Keep only the last 20 viewed products
    if (viewedProducts.length > 20) {
      viewedProducts = viewedProducts.slice(0, 20);
    }
    
    // Save back to localStorage
    localStorage.setItem('recentlyViewedProducts', JSON.stringify(viewedProducts));
  }

  /**
   * Enhance Buy Again buttons with quick add functionality
   */
  function enhanceBuyAgainButtons() {
    const buyAgainForms = document.querySelectorAll('.buy-again-form');
    
    buyAgainForms.forEach(form => {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        const variantId = form.querySelector('input[name="id"]').value;
        const quantity = form.querySelector('input[name="quantity"]').value;
        const submitButton = form.querySelector('.buy-again-button');
        
        // Change button text to indicate loading
        const originalText = submitButton.textContent;
        submitButton.textContent = 'Adding...';
        submitButton.disabled = true;
        
        // Add to cart using Fetch API
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: quantity
            }]
          })
        })
        .then(response => response.json())
        .then(data => {
          // Success - update button text
          submitButton.textContent = 'Added!';
          
          // Update mini-cart if it exists
          if (typeof updateMiniCart === 'function') {
            updateMiniCart();
          }
          
          // Reset button after 2 seconds
          setTimeout(() => {
            submitButton.textContent = originalText;
            submitButton.disabled = false;
          }, 2000);
        })
        .catch(error => {
          // Error - reset button
          submitButton.textContent = 'Try Again';
          submitButton.disabled = false;
          console.error('Error adding product to cart:', error);
        });
      });
    });
  }

  /**
   * Add quantity selectors to Buy Again items
   */
  function addQuantitySelectors() {
    const buyAgainItems = document.querySelectorAll('.buy-again-item');
    
    buyAgainItems.forEach(item => {
      const form = item.querySelector('.buy-again-form');
      const quantityInput = form.querySelector('input[name="quantity"]');
      
      // Create quantity selector container
      const quantitySelector = document.createElement('div');
      quantitySelector.className = 'quantity-selector';
      
      // Create decrease button
      const decreaseBtn = document.createElement('button');
      decreaseBtn.type = 'button';
      decreaseBtn.className = 'quantity-btn decrease';
      decreaseBtn.textContent = '-';
      decreaseBtn.addEventListener('click', function() {
        const currentVal = parseInt(quantityInput.value);
        if (currentVal > 1) {
          quantityInput.value = currentVal - 1;
        }
      });
      
      // Create quantity display
      const quantityDisplay = document.createElement('span');
      quantityDisplay.className = 'quantity-display';
      quantityDisplay.textContent = quantityInput.value;
      
      // Update quantity input when display changes
      quantityInput.addEventListener('change', function() {
        quantityDisplay.textContent = this.value;
      });
      
      // Create increase button
      const increaseBtn = document.createElement('button');
      increaseBtn.type = 'button';
      increaseBtn.className = 'quantity-btn increase';
      increaseBtn.textContent = '+';
      increaseBtn.addEventListener('click', function() {
        const currentVal = parseInt(quantityInput.value);
        quantityInput.value = currentVal + 1;
        quantityDisplay.textContent = quantityInput.value;
      });
      
      // Assemble quantity selector
      quantitySelector.appendChild(decreaseBtn);
      quantitySelector.appendChild(quantityDisplay);
      quantitySelector.appendChild(increaseBtn);
      
      // Insert before the Buy Again button
      form.insertBefore(quantitySelector, form.querySelector('.buy-again-button'));
    });
    
    // Add styles for quantity selectors
    const style = document.createElement('style');
    style.textContent = `
      .quantity-selector {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        justify-content: center;
      }
      
      .quantity-btn {
        background-color: #f1f1f1;
        border: 1px solid #ddd;
        width: 25px;
        height: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 16px;
        user-select: none;
      }
      
      .quantity-btn:hover {
        background-color: #e1e1e1;
      }
      
      .quantity-display {
        padding: 0 10px;
        min-width: 30px;
        text-align: center;
      }
    `;
    document.head.appendChild(style);
  }
});